import { useMemo } from "react"

import { useGetFileUploadData } from "@/components/upload/hooks/useGetFileUploadData"
import type { SignedUrl } from "@/graphql/codegen/graphql"
import { ReferenceTableName } from "@/graphql/codegen/graphql"

export interface UseGetTransferDocumentsReturn {
  documents: SignedUrl[]
  isFetching: boolean
  refetch: (immediate?: boolean) => void
}

export const useGetTransferDocuments = (transferId?: string): UseGetTransferDocumentsReturn => {
  const { fileList, fileFetching, refetchFileUploadData } = useGetFileUploadData({
    referenceId: transferId,
    referenceTableName: ReferenceTableName.Transfer,
    pause: !transferId,
  })

  // Keeping this reference stable across renders (not just across data changes) lets TransferFormPage
  // detect a genuine refetch via reference comparison instead of re-deriving on every render.
  const documents = useMemo(() => fileList.filter((signedUrl) => !signedUrl.file?.isArchived), [fileList])

  return { documents, isFetching: fileFetching, refetch: refetchFileUploadData }
}
